import ParticipantsCard from "./ParticipantsCard";

export default ParticipantsCard;
